import { useTranslation } from "react-i18next";
import { useObjectCard } from "../context/ObjectCardProvider";
import { useState } from "react";
import { Button } from "react-bootstrap";
import SvgPlus from "components/svg/SvgPlus";
import SpinnerBlock from "components/others/SpinnerBlock";
import AddExpendModal from "./AddExpendModal";
import SvgMinus from "components/svg/SvgMinus";
import OffExpendInfo from "../OffExpendInfo";
import OexpendOtherBody from "./OexpendOtherBody";
import useSettingsParams from "hooks/useSettingsParams";

const ObjectTabOther = ({vOnject}) => {
    const { t } = useTranslation(['Objects']);
    const { vObject, objectId, isEditLocked } = useObjectCard();
    const params = useSettingsParams();
    const hideIncome = Boolean(params.includeOtherInObjectCost);
    const [ showAddExpendModal, setShowAddExpendModal ] = useState(false);
    const [ showSpinnerExpend, setShowSpinnerExpend ] = useState(false);
    const [ showExpandInfo, setShowExpendInfo ] = useState(false);

    return (<>
          
         <AddExpendModal
            showObject={showAddExpendModal}
            setShowObject={setShowAddExpendModal}/>
 
        <OffExpendInfo
            objectId={objectId}
            show={showExpandInfo}
            setShow={setShowExpendInfo}/>            
         
        <div>   
        {showSpinnerExpend && (<SpinnerBlock onlyBlur={true} show={true}/>)}
        
        <OexpendOtherBody
            expends={vObject.expends} 
            setShowExpendInfo={setShowExpendInfo} 
            setShowSpinnerExpend={setShowSpinnerExpend}/>

        </div> 
 
        {!isEditLocked && 
        (<div className="text-center w-100 mt-4 ">
            <Button className="m-1 py-2"
                variant="danger"
                size="sm"
                onClick={()=>{
                    setShowAddExpendModal({objectId, income:false})
                }}>
                <SvgMinus className="me-2"/> 
                {t('addExpend.btnAddExpend')}</Button>

            {!hideIncome && (
            <Button className="m-1 py-2"
                variant="success"
                size="sm"
                onClick={()=>{
                    setShowAddExpendModal({objectId, income:true})
                }}>
                <SvgPlus className="me-2"/> 
                {t('addExpend.btnAddIncome')}</Button>
            )}
        </div>)}
    </>)
}

export default ObjectTabOther;